/**
 * 移动设备识别（首屏选 H5 / PC 首页用），不替代响应式 CSS。
 */
export function isMobileUserAgent() {
  if (typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent || "";
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|UCBrowser|MQQBrowser|MicroMessenger/i.test(
    ua
  );
}

const PREFER_DESKTOP_KEY = "yqq_prefer_desktop";

/** 用户主动选择「始终用桌面版」后，不再自动进 H5 首页 */
export function getPreferDesktop() {
  try {
    return localStorage.getItem(PREFER_DESKTOP_KEY) === "1";
  } catch {
    return false;
  }
}

export function setPreferDesktop(on) {
  try {
    if (on) {
      localStorage.setItem(PREFER_DESKTOP_KEY, "1");
    } else {
      localStorage.removeItem(PREFER_DESKTOP_KEY);
    }
  } catch {
    /* noop */
  }
}
